import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { requestByConnection, ResponseDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';
import { fillFioAction } from '@r1-frontend/entities/ContactDetail/actions/fillFio';
import { fillPhoneAction } from '@r1-frontend/entities/ContactDetail/actions/fillPhone';
import { isPersonDataFilled } from '@r1-frontend/entities/ContactDetail/selectors/isPersonDataFilled';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { useResultPopup } from '@r1-frontend/ui-react/components/popups/useResultPopup';

import { PersonForm } from '~/src/components/PersonForm';
import { BgThrobber } from '~/src/components/ThrobberWithBg';
import { TState } from '~/src/store';
import { selectCsrf } from '~/src/store/selectors/auth/selectCsrf';

import * as ST from './styled';

export type TContactDetailsCallbacks = {
    onClickChangeAddress: () => void,
}

const EditableContactsForm = ({
    onClickChangeAddress,
}: TContactDetailsCallbacks): JSX.Element => {
    const [isLoading, setIsLoading] = useState(false);
    const [PopupResult, showResult] = useResultPopup();

    const {
        fio,
        phone,
        isPersonData,
        csrf,
    } = useSelector((state: TState) => ({
        fio: state.contactDetails.editedFio,
        phone: state.contactDetails.editedPhone,
        isPersonData: isPersonDataFilled(state),
        csrf: selectCsrf(state),
    }));

    const dispatch = useDispatch();

    const onFillFio = (_person: string) => {
        dispatch(fillFioAction(_person));
    };

    const onFillPhone = (_phone: string) => {
        dispatch(fillPhoneAction(_phone));
    };

    const onSendRequest = async() => {
        setIsLoading(true);

        const resp = await doRequest.apiRequest<ResponseDto>(
            requestByConnection({
                petition: 'create_request',
                fio,
                phone,
                product_id: [0],
                csrf,
            }),
        );
        if (resp.isSuccess) {
            showResult({
                type: EResultPopupStatus.SUCCESS,
                title: 'Заявка на подключение отправлена',
                text: resp.payload.message,
            });
        } else {
            showResult({
                type: EResultPopupStatus.ERROR,
                title: 'Произошла ошибка',
                text: 'Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.',
            });
        }

        setIsLoading(false);
    };

    return (
        <ST.EditableContactsForm>
            <PersonForm
                fio={fio}
                phone={phone}
                onChangeFio={onFillFio}
                onChangePhone={onFillPhone}
                isNeedToBlockInvalidFio
                actionButtonProps={{
                    children: 'Оставить заявку',
                    onClick: onSendRequest,
                    disabled: !isPersonData,
                }}
            />
            <ST.BtnWrap>
                <ST.Button
                    type={btnTypes.SECONDARY}
                    text={'Проверить другой адрес'}
                    onClick={onClickChangeAddress}
                />
            </ST.BtnWrap>

            <PopupResult/>

            {isLoading && <BgThrobber/>}
        </ST.EditableContactsForm>
    );
};

export default memo(EditableContactsForm);
